import React, { FC, useState, useEffect, StatusTip  } from 'react';
import defaultKol from '@/pages/intelligence/assets/svg/tipicon/kol-default.svg';
import loadingSvg from '@/pages/intelligence/assets/svg/loading.svg';
import './index.scss';

interface TableImageProps {
  src: string;
  width?: number;
  height?: number;
  defaultImage?: string;
  onClick?: (info: any) => void;
  imageInfo?: any;
}

const TableImage: FC<TableImageProps> = (props) => {
  const { src, defaultImage, onClick, imageInfo, width, height } = props;
  const [loading, setLoading] = useState(true);
  const [imageSrc, setImageSrc] = useState(defaultImage || defaultKol);

  useEffect(() => {
    if (src) {
      const newImg = new Image();
      newImg.src = src;
      newImg.onerror = () => {
        setImageSrc(defaultImage || defaultKol);
        setLoading(false);
      };
      newImg.onload = () => {
        setImageSrc(newImg.src);
        setLoading(false);
      };
    }else{
      setImageSrc(defaultImage || defaultKol);
      setLoading(false);
    }
  }, [src]);

  return loading ? (
    <div className='dbi-table-img-loading-container'>
      <img src={loadingSvg} className='image-loading'/>
    </div>
  ) : (
    <img
      src={imageSrc}
      className="dbi-table-image-source-user"
      width={width || 54}
      height={height || 54}
      onClick={() => {
        onClick?.(imageInfo);
      }}
    />
  );
};

export default TableImage;
